<template>
  <div class="clue-module">
    <el-dialog :title="mytitle" :visible.sync="showUpdate" width="960px" :close-on-click-modal="false" center>
      <el-form label-width="100px" :model="updateClue" ref="updateClue" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="意向城市" prop="cityId">
              <el-select v-model="updateClue.cityId" :disabled="addOrUpdate == 3" clearable placeholder="请选择意向城市"
                filterable @change="cityChange1">
                <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName" filter
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务者名称" prop="workerName">
              <el-input v-model="updateClue.workerName" :disabled="addOrUpdate == 3" placeholder="请输入服务者姓名"
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addOrUpdate == 2">
          <el-col :span="12">
            <el-form-item label="跟进人" prop="handlerId">
              <el-select v-model="updateClue.handlerId" placeholder="请选择跟进人">
                <el-option v-for="item in allhandlerList" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务者电话" prop="tel">
              <el-input v-model="updateClue.tel" :disabled="addOrUpdate == 2 || addOrUpdate == 3" maxlength="11"
                placeholder="请输入服务者电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号码" prop="idCard">
              <el-input v-model="updateClue.idCard" maxlength="18" show-word-limit placeholder clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="微信号" prop="wxAccount">
              <el-input v-model="updateClue.wxAccount" :disabled="addOrUpdate == 3" placeholder="请输入微信号"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄" prop="age">
              <el-input v-model="updateClue.age" :disabled="addOrUpdate == 3" placeholder="请输入年龄" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="户口" prop="residenceType">
                <el-select v-model="updateClue.residenceType" :disabled="addOrUpdate == 3" placeholder="请选择户口"
                  filterable>
                  <el-option v-for="(item, index) in residenceTypeMap" :key="index" :label="item"
                    :value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="社保" prop="socialSecurity">
                <el-select v-model="updateClue.socialSecurity" :disabled="addOrUpdate == 3" placeholder="请选择社保"
                  filterable>
                  <el-option :disabled="updateClue.residenceType != 2" label="社保" :value="1"></el-option>
                  <el-option :disabled="updateClue.residenceType != 1" label="新农保" :value="2"></el-option>
                  <el-option :disabled="updateClue.residenceType != 2" label="已退休" :value="3"></el-option>
                  <el-option label="无" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="12">
            <el-form-item label="当前城市" prop="currentCity">
              <el-select v-model="updateClue.currentCity" :disabled="addOrUpdate == 3" clearable placeholder="请选择意向城市"
                filterable @change="cityChange">
                <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="updateClue.currentCity == 2" label="城市区域" prop="currentCity">
              <el-select v-model="updateClue.cityArea" :disabled="addOrUpdate == 3" clearable placeholder="请选择城市区域"
                filterable>
                <el-option :key="1" label="浦东" :value="1"></el-option>
                <el-option :key="2" label="浦西" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前所在地" prop="currentAddress">
              <el-input v-model="updateClue.currentAddress" :disabled="addOrUpdate == 3" placeholder="请输入当前所在地"
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="期望收入" prop="salaryHope">
              <el-input v-model="updateClue.salaryHope" :disabled="addOrUpdate == 3" placeholder="请输入期望收入"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位兴趣" prop="positionInterest">
              <el-input v-model="updateClue.positionInterest" :disabled="addOrUpdate == 3" placeholder="请输入职位兴趣"
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item label="服务者类型" prop="workerType">
                    <el-select v-model="updateClue.workerType" style="width:100%" clearable placeholder="请选择服务类型" filterable>
                        <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
        </el-form-item>-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="求职意向" prop="joinDemands">
              <el-select v-model="updateClue.joinDemands" :disabled="addOrUpdate == 3" style="width:100%" multiple
                clearable placeholder="请选择服务类型" filterable>
                <el-option v-for="(item, index) in workTypes" :key="index" :label="item.label"
                  :value="item.value + ''"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源类型" prop="sourceType">
              <el-radio-group v-model="updateClue.sourceType" :disabled="operType == 1 || addOrUpdate == 3"
                @change="chooseSourceType">
                <el-radio :label="3">自招</el-radio>
                <el-radio :label="4">转介绍</el-radio>
                <el-radio :label="1">外部渠道</el-radio>
                <el-radio :label="7">自有渠道</el-radio>
                <!-- <el-radio :label="2">合伙人</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="operType == 1">
            <!--合伙人推荐保洁师-->
            <el-form-item label="来源" prop="sourceRelationId">
              <el-select disabled v-model="updateClue.sourceRelationId" :disabled="addOrUpdate == 3 || operType == 1"
                style="width:100%" @change="sourceRelationChange" clearable placeholder="请选择来源" filterable>
                <template v-for="(item, index) in supplierList">
                  <el-option v-if="item.sourceType == updateClue.sourceType || item.sourceType == 7" :key="index"
                    :label="item.name + item.tel" :value="item.id"></el-option>
                </template>
              </el-select>
              <div>*来源为服务者线索来源提供者，请如实填写</div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <!--自己公司录入保洁师-->
            <el-form-item label="来源" prop="sourceRelationId">
              <el-select v-model="updateClue.sourceRelationId" :disabled="addOrUpdate == 3" style="width:100%"
                @change="sourceRelationChange" clearable placeholder="请选择来源" filterable>
                <template v-for="(item, index) in supplierList">
                  <el-option v-if="item.sourceType == updateClue.sourceType && updateClue.sourceType != 7" :key="index"
                    :label="item.name + item.tel" :value="item.id"></el-option>
                </template>

                <el-option v-if="updateClue.sourceType == 7" key="1371" label="新媒体" :value="1371"></el-option>
              </el-select>
              <div>*来源为服务者线索来源提供者，请如实填写</div>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="updateClue.sourceType == 1">
            <el-form-item label="渠道对接人" prop="sourceRelationPerson">
              <el-input v-model="updateClue.sourceRelationPerson" :disabled="addOrUpdate == 3" placeholder
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="归属" prop="workerBelongId">
              <el-select :disabled="operType == 1 || addOrUpdate == 3" v-model="updateClue.workerBelongId"
                style="width:100%" @change="workerBelongChange" clearable placeholder="请选择归属" filterable>
                <!--                <template v-for="(item, index) in supplierList">
                  <el-option v-if="item.sourceType == 7||item.sourceType == 1" :key="index" :label="item.name" :value="item.id"></el-option>
                </template>-->
                <el-option label="宅洁士" :value="1327"></el-option>
              </el-select>
              <div>*请选择要输送服务者去哪家公司</div>
              <div>注意：如果归属选择自己公司，此服务者仅您账号可见</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="addOrUpdate == 1">
          <el-col :span="12">
            <el-form-item label="跟进时间" prop="followTime">
              <div class="block">
                <el-date-picker v-model="updateClue.followTime" :disabled="addOrUpdate == 3"
                  :append-to-body="false" popper-class="worker-follow-time-picker" type="datetime"
                  format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择日期"></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>


      <div v-if="addOrUpdate == 3">
        <center style="color:red;">若以上信息不完整，请先修改线索，再发起邀约上线</center>
        <el-divider><span style="color:red;">选择邀请入职的城市和服务站</span></el-divider>
        <el-form label-width="100px" :model="joinPositionDto">
          <el-row>
            <el-col :span="12">
              <el-form-item label="城市" prop="cityId">
                <el-select v-model="joinPositionDto.cityId"  @change="selectCity" placeholder="请选择城市" filterable>
                  <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="驿站" prop="postStationId">
                <el-select v-model="joinPositionDto.postStationId" placeholder="请选择驿站" filterable>
                  <template v-for="(item, index) in postStationList">
                    <el-option :key="index" v-if="item.cityId == joinPositionDto.cityId" :label="item.postStationName"
                      :value="item.id + ''"> </el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="服务站" prop="stationId">
                <el-select v-model="joinPositionDto.stationId" placeholder="请选择服务站" filterable>
                  <template v-for="(item, index) in allStationList">
                    <el-option :key="index" v-if="item.cityId == joinPositionDto.cityId"
                      :label="item.stationName" :value="item.id + ''"> </el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上线类型" prop="workerType">
                <el-select v-model="joinPositionDto.workerType" style="width:100%" clearable placeholder="请选择上线类型"
                  filterable>
                  <el-option v-for="(item, index) in workTypes" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上线签约主体" prop="creditCode">
                <el-select v-model="joinPositionDto.creditCode" style="width:100%" clearable placeholder="请选择上线签约主体"
                  filterable>
                  <el-option v-for="(item, index) in creditCodeList" :key="index" :label="item.companyName"
                    :value="item.creditCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="备注" prop="comment">
              <el-input type="textarea" rows="1" v-model="joinPositionDto.comment" placeholder="请输入上线备注"
                clearable></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showUpdate = false">关闭</el-button>
        <el-button v-if="addOrUpdate == 1 || addOrUpdate == 2" type="primary" @click="saveCreate">提交</el-button>
        <el-button v-if="addOrUpdate == 3" type="primary" @click="postOffice">邀请上线</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import taskApi from "@/script/api/taskApi";
import {
  validatePhoneTwo,
  validateIdNo,
  validateIdNotmust,
  validateIdNoOrNull,
  validateNumber
} from "@/script/validator";

let vm;
export default {
  data() {
    return {
      allhandlerList: [],
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" },
      ],
      joinPositionDto: {
        workerNo: '',
        cityId: '',
        postStationId: '',
        stationId: '',
        workerType: '',
        comment: '',
        operUserId: '',
        operName: '',
        creditCode: ''
      },
      postStationList: [],
      allStationList: [],
      addOrUpdate: 1,//1新增，2修改，3邀请入职
      operType: 0,//1 是合伙人推荐保洁师
      mytitle: '新增线索',
      residenceTypeMap: { 1: '农村', 2: '城镇' },
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" }
      ],
      cityList: [],
      supplierList: [],
      showUpdate: false,
      updateClue: {
        addType: 2,
        cityId: "",
        workerName: "",
        workerType: "",
        sourceType: 3,
        idCard: "",
        tel: "",
        sourceRelationId: "",
        sourceRelationName: "",
        workerBelongId: "",
        workerBelongName: "",
        workerType: "",
        joinDemands: [],
        ofJz: null,
        idCard: null,
        sourceRelationPerson: '',
        wxAccount: '',
        age: '',
        residenceType: '',
        socialSecurity: '',
        currentAddress: '',
        currentCity: '',
        salaryHope: '',
        positionInterest: '',
        followTime: '',
        cityArea: '',
        handlerId: ''
      },
      creditCodeList: [],
      rules: {
        cityId: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change"
          }
        ],
        workerName: [
          {
            required: true,
            message: "请输入服务者名称",
            trigger: "change"
          }
        ],
        tel: [
          {
            required: true,
            message: "请输入服务者联系方式",
            trigger: "change"
          },
          {
            validator: validatePhoneTwo,
            message: "手机号码格式错误",
            trigger: "change"
          }
        ],
        idCard: [
          {
            validator: validateIdNotmust,
            message: "身份证号码格式错误",
            trigger: "change"
          }
        ],
        sourceType: [
          {
            required: true,
            message: "请选择服务者来源类型",
            trigger: "change"
          }
        ],
        sourceRelationId: [
          {
            required: true,
            message: "请选择服务者来源",
            trigger: "change"
          }
        ],
        workerBelongId: [
          {
            required: true,
            message: "请选择服务者归属",
            trigger: "change"
          }
        ],
        joinDemands: [
          {
            required: true,
            message: "请选择求职意向",
            trigger: "change"
          }
        ],
        followTime: [
          {
            required: true,
            message: "请选择跟进时间",
            trigger: "change"
          }
        ],
        handlerId: [
          {
            required: true,
            message: "请选择跟进人",
            trigger: "change"
          }
        ]

        // residenceType: [
        //   {
        //     required: true,
        //     message: "请选择户口",
        //     trigger: "change"
        //   }
        // ],
        // socialSecurity: [
        //   {
        //     required: true,
        //     message: "请选择社保",
        //     trigger: "change"
        //   }
        // ]
      }
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    selectCity(v){
       this.joinPositionDto.stationId='';
    },
    getAllHandle(value) {
      taskApi.$axiosGetClueHandleName({ cityId: value }).then(res => {
        this.allhandlerList = res.data.data;
      });
    },
    postOffice() {
      console.log(this.joinPositionDto);
      if (this.joinPositionDto.cityId == '') {
        this.$message.error("请选择城市");
        return;
      }
      // if (this.joinPositionDto.postStationId == '') {
      //   this.$message.error("请选择驿站");
      //   return;
      // }
      if (this.joinPositionDto.stationId == '') {
        this.$message.error("请选择服务站");
        return;
      }
      if (this.joinPositionDto.workerType == '') {
        this.$message.error("请选择上线类型");
        return;
      }
      if (this.isEmptyObjVue(this.updateClue.idCard)) {
        this.$message.error("请输入身份证号码");
        return;
      }
      workercrmapi
        .$axiosGetTakeOffice(this.joinPositionDto)
        .then((res) => {
          this.$message.success("操作成功，请尽快到小程序完善个信息");
          this.showUpdate = false;
          this.$parent.querySearch();
        });
    },
    toUpdate(row, addOrUpdate) {
      //修改线索，邀请上线操作
      let temp = JSON.parse(JSON.stringify(row));
      this.addOrUpdate = addOrUpdate;//1新增2修改 ,3邀请入职
      if (addOrUpdate == 2) {
        this.mytitle = '修改线索';
        this.getAllHandle();
      }

      if (addOrUpdate == 3) {
        this.mytitle = '邀请上线';
        this.joinPositionDto = {
          workerNo: temp.workerNo,
          cityId: temp.cityId,
          postStationId: '',
          stationId: '',
          workerType: '',
          comment: '',
          operUserId: globalData.userInfo.id,
          operUserName: globalData.userInfo.userName
        }
        // this.getAllPostStation();
        this.getAllStationList();
        this.getAllMainBody();
      }


      this.updateClue = temp;
      this.updateClue.joinDemands = temp.joinDemand.split(',');
      this.updateClue.sourceRelationId = temp.sourceRelationId * 1;
      this.updateClue.residenceType = temp.residenceType + '';

      this.getAllCity();
      this.getSupplierList();
      this.showUpdate = true;
    },
    chooseSourceType() {
      this.updateClue.sourceRelationId = null;
      this.updateClue.sourceRelationName = null;
    },
    showAddWorkerClue(addType, operType) {
      //add_type 1是公海，2是我的线索录入
      //operType=1 是合伙人推荐保洁师
      this.operType = operType;
      this.addOrUpdate = 1;

      this.getAllCity();
      this.getSupplierList();

      this.showUpdate = true;
      this.updateClue = {
        addType: addType,
        cityId: "",
        cityName: "",
        workerName: "",
        workerType: "",
        sourceType: 3,
        idCard: "",
        tel: "",
        sourceRelationId: "",
        sourceRelationName: null,
        workerBelongId: globalData.franchisee.id,
        workerBelongName: null,
        workerType: "",
        joinDemand: [],
        ofJz: null,
        idCard: null,
        currentCity: '',
        salaryHope: '',
        positionInterest: '',
        followTime: '',
        operUserId: globalData.userInfo.id,
        operUserName: globalData.userInfo.userName
      };

      if (operType == 1) {
        //合伙人推荐
        this.updateClue.sourceType = 1;
        this.updateClue.workerBelongId = 1327;
        this.updateClue.workerBelongName = "宅洁仕";
        this.updateClue.sourceRelationId = globalData.franchisee.id;
        this.updateClue.sourceRelationName =
          globalData.franchisee.franchiseeShortName;
      }
    },
    operUpdate() {
      this.$refs["updateClue"].validate(valid => {
        if (valid) {
          console.log(this.updateClue);
          this.updateClue.joinDemand = this.updateClue.joinDemands.join(",");
          workercrmapi.$axiosUpdateWorkerClue(this.updateClue).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
              this.showUpdate = false;
              this.$parent.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        }
      });
    },
    saveCreate() {
      if (this.addOrUpdate == 2) {
        //修改
        this.operUpdate();
        return;
      }

      console.info(this.updateClue);

      this.workerBelongChange(this.updateClue.workerBelongId);//防止没选过
      this.$refs["updateClue"].validate(valid => {
        if (valid) {
          console.log(this.updateClue);
          this.updateClue.joinDemand = this.updateClue.joinDemands.join(",");
          workercrmapi.$axiosAddWorkerClue(this.updateClue).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
              this.showUpdate = false;
              this.$parent.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        }
      });
    },

    workerBelongChange(value) {
      this.supplierList.forEach(item => {
        if (item.id == value && (item.sourceType == 7 || item.sourceType == 1)) {

          this.updateClue.ofJz = item.companyId;

          this.updateClue.workerBelongName = item.name;
        }
      });
    },
    sourceRelationChange(value) {
      let boo = false;
      this.supplierList.forEach(item => {
        if (item.id == value && item.sourceType == this.updateClue.sourceType) {
          boo = true;
          this.updateClue.sourceRelationName = item.name;
        }
      });
      if (boo == false) {
        if (item.id == value && item.sourceType == 7) {
          boo = true;
          this.updateClue.sourceRelationName = item.name;
        }
      }
    },
    cityChange1(value) {
      this.updateClue.cityId = value;
      this.updateClue.cityName = this.cityList.find(item => item.id == value).cityName;
      //清除handlerId
      this.updateClue.handlerId = '';
      this.getAllHandle(value);

    },
    cityChange(value) {
      this.cityList.forEach(item => {
        if (item.id == value) this.updateClue.cityName = item.cityName;
      });
    },
    getSupplierList() {
      //获取归属
      workercrmapi
        .$axiosGetSupplierList({ companyId: globalData.company.id })
        .then(res => {
          this.supplierList = res.data.data;
        });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then(res => {
        if (res.data.errno == 0) {
          let data = res.data.data;
          // //排除上海市
          // data = data.filter(item => item.cityName != '上海市');
          this.cityList = data;
        }
      });
    },
    getAllPostStation() {
      workercrmapi.$axiosPostStationgetAllList().then((res) => {
        if (res.data.errno == 0) {
          this.postStationList = res.data.data;
        }
      });
    },
    getAllStationList() {
      //服务站
      wmsApi.$axiosGetAllStationList().then((res) => {
        if (res.data.errno == 0) {
          this.allStationList = res.data.data;
        }
      });
    },
    getAllMainBody() {
      workercrmapi
        .$axiosGetMainBody()
        .then((res) => {
          this.creditCodeList = res.data.data
        });
    }
  }
};
</script>
<style scoped>
.el-dialog--center .el-dialog__body {
  padding: 24px 40px 24px 20px !important;
}

.clue-module .el-select {
  width: 100%;
}

.clue-module .el-radio {
  margin-right: 12px;
}

.block >>> .worker-follow-time-picker {
  position: absolute !important;
  top: auto !important;
  right: auto !important;
  bottom: calc(100% + 8px) !important;
  left: 0 !important;
  margin: 0 !important;
  transform: none !important;
}

.block >>> .worker-follow-time-picker .popper__arrow {
  display: none;
}
</style>
